var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33398 76.6654H76.6673V3.33203H3.33398V76.6654Z",
    fill: "#FEFEFE",
    stroke: "white",
    strokeWidth: 4.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.877 33.4724L49.0669 57.6287L57.9758 56.0232C57.9758 56.0232 67.8019 53.7496 64.5722 40.9797C64.5722 40.9797 62.449 32.6905 53.8664 31.9516C53.8664 31.9516 52.8257 31.867 51.7849 31.9932C52.784 31.9793 44.877 33.4724 44.877 33.4724Z",
    fill: "#0F2A6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4954 25.5456L51.0788 23.8569C53.1603 23.6753 55.9039 22.0283 55.9039 22.0283C62.5003 13.6033 57.7397 7.48383 56.3001 5.84375H40.1152L43.4954 25.5456Z",
    fill: "#0F2A6A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5156 25.6579C70.7073 27.2896 73.001 29.1113 73.694 29.7574V5.84375H69.4584C73.788 19.0116 65.5156 25.6579 65.5156 25.6579Z",
    fill: "#0F2A6A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.003 5.84375H6.89062V61.0729H35.1966L26.003 5.84375Z",
    fill: "#0F2A6A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3359 61.0736H73.6959V58C72.6471 59.3545 71.1779 60.4788 70.3359 61.0736Z",
    fill: "#0F2A6A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.877 33.4724L49.0669 57.6287L57.9758 56.0232C57.9758 56.0232 67.8019 53.7496 64.5722 40.9797C64.5722 40.9797 62.449 32.6905 53.8664 31.9516C53.8664 31.9516 52.8257 31.867 51.7849 31.9932C52.784 31.9793 44.877 33.4724 44.877 33.4724Z",
    fill: "#0F2A6A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4954 25.5456L51.0788 23.8569C53.1603 23.6753 55.9039 22.0283 55.9039 22.0283C62.5003 13.6033 57.7397 7.48383 56.3001 5.84375H40.1152L43.4954 25.5456Z",
    fill: "#0F2A6A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5156 25.6579C70.7073 27.2896 73.001 29.1113 73.694 29.7574V5.84375H69.4584C73.788 19.0116 65.5156 25.6579 65.5156 25.6579Z",
    fill: "#0F2A6A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.003 5.84375H6.89062V61.0729H35.1966L26.003 5.84375Z",
    fill: "#0F2A6A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3359 61.0736H73.6959V58C72.6471 59.3545 71.1779 60.4788 70.3359 61.0736Z",
    fill: "#0F2A6A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4385 67.373H48.434L48.4502 70.3621C48.4502 70.3621 48.9417 70.9139 49.4708 70.3094L49.5044 67.3841H51.4234L51.3912 70.9929C51.3912 70.9929 51.1588 71.962 50.3423 72.0285H47.3543C47.3543 72.0285 46.648 71.9495 46.4277 70.8681L46.4385 67.373Z",
    fill: "#0F2A6A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8926 67.3757V72.0894H57.0395V70.6905H54.723V70.3703H57.0395V69.1281H54.7552V68.7524H57.0288V67.3535L52.8926 67.3757Z",
    fill: "#0F2A6A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3633 67.3516H60.3051V72.0874H58.3969L58.3633 67.3516Z",
    fill: "#0F2A6A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7774 69.4237V68.8719H64.6436C64.6436 68.8719 64.8464 68.858 64.8464 69.2005C64.8464 69.2005 64.7873 69.4084 64.6288 69.4251C64.4704 69.4389 63.7774 69.4237 63.7774 69.4237ZM61.8933 67.3594L61.8262 67.3732V72.0661H63.8419V70.8711L63.9816 70.9099C63.9816 70.9099 64.6839 72.1826 66.9709 72.0814L66.9789 70.3373C66.9789 70.3373 66.4136 70.4344 66.0134 70.2569C66.0134 70.2569 66.8138 69.6621 66.7856 68.865C66.7856 68.865 66.7533 67.6547 65.8106 67.3594H61.8933Z",
    fill: "#0F2A6A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0681 67.332C69.3988 67.332 68.0371 68.3995 68.0371 69.7069C68.0371 71.0142 69.3988 72.0818 71.0681 72.0818C72.7373 72.0818 74.099 71.0142 74.099 69.7069C74.099 68.3995 72.7373 67.332 71.0681 67.332ZM71.1339 70.6233C71.1339 70.6233 70.269 70.6801 70.269 69.7124C70.269 69.7124 70.2046 68.9735 70.9096 68.7614H71.0493C71.0493 68.7614 71.8953 68.724 71.8859 69.7499C71.8859 69.7499 71.8765 70.5082 71.1339 70.6233Z",
    fill: "#0F2A6A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76559 70.8527V70.2996H9.63178C9.63178 70.2996 9.83321 70.2871 9.83321 70.6295C9.83321 70.6295 9.77413 70.8375 9.61566 70.8527C9.45854 70.8666 8.76559 70.8527 8.76559 70.8527ZM8.77365 69.2764V68.7246H9.63983C9.63983 68.7246 9.84127 68.7094 9.84127 69.0518C9.84127 69.0518 9.78353 69.2625 9.62372 69.2764C9.4666 69.2917 8.77365 69.2764 8.77365 69.2764ZM6.75391 67.4117L6.79688 72.088L11.1546 72.0741C11.1546 72.0741 13.0455 70.9109 11.3131 69.7478C11.3131 69.7478 12.6547 68.3032 10.8082 67.3965L6.75391 67.4117Z",
    fill: "#0F2A6A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4548 67.3984H14.6119L12.8809 72.1509L14.8724 72.1648L15.1746 71.4189H16.7901L17.1943 72.1412H19.3013L17.4548 67.3984ZM15.6365 70.0326L16.0125 69.0649L16.3442 70.0326H15.6365Z",
    fill: "#0F2A6A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0883 69.4444V68.8926H22.9545C22.9545 68.8926 23.156 68.8788 23.156 69.2212C23.156 69.2212 23.0969 69.4306 22.9384 69.4444C22.7813 69.4597 22.0883 69.4444 22.0883 69.4444ZM20.2136 67.3926L20.1465 67.4078V72.1007H22.1609V70.9043L22.3019 70.9445C22.3019 70.9445 23.0042 72.2172 25.2912 72.1146V70.3636C25.2912 70.3636 24.7742 70.4495 24.374 70.2735C24.374 70.2735 25.1341 69.6954 25.1059 68.8968C25.1059 68.8968 25.1206 67.6865 24.1766 67.3926H20.2136Z",
    fill: "#0F2A6A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.296 69.4594V68.909H29.1622C29.1622 68.909 29.3636 68.8938 29.3636 69.2362C29.3636 69.2362 29.3045 69.4455 29.146 69.4608C28.9889 69.476 28.296 69.4594 28.296 69.4594ZM26.4011 67.3965L26.334 67.4103V72.1032H28.3497V70.9068L28.4894 70.947C28.4894 70.947 29.1917 72.2211 31.4787 72.1171L31.4868 70.3744C31.4868 70.3744 30.9214 70.4701 30.5212 70.294C30.5212 70.294 31.3216 69.6965 31.2934 68.9021C31.2934 68.9021 31.3068 67.6918 30.3641 67.3965H26.4011Z",
    fill: "#0F2A6A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5258 67.3984H33.6841L31.9531 72.1496L33.9433 72.1648L34.2468 71.4203H35.8624L36.2666 72.1412H38.3736L36.5258 67.3984ZM34.7021 70.0118L35.0767 69.0441L35.4085 70.0118H34.7021Z",
    fill: "#0F2A6A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.821 69.778H42.659C42.659 69.778 42.8134 69.1153 42.1514 68.8214C42.1514 68.8214 41.3026 68.5358 41.0381 69.3676C41.0381 69.3676 40.8716 70.119 41.402 70.5045L41.5564 70.5516L42.142 70.5738C42.142 70.5738 41.8317 70.3811 41.7874 69.8806L41.821 69.778ZM41.8479 72.1348C40.2055 72.1348 38.8652 70.9966 38.8652 69.6699C38.8652 68.3431 40.2055 67.2617 41.8479 67.2617C43.4916 67.2617 44.8318 68.3431 44.8318 69.6699C44.8318 69.6699 44.8976 69.9236 44.7324 70.4712H45.6255V72.0544C45.6255 72.0544 44.1926 72.1917 43.4741 71.7245C43.4741 71.7245 42.9128 72.0433 42.5045 72.0891C42.0963 72.1348 41.8479 72.1348 41.8479 72.1348Z",
    fill: "#0F2A6A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9727 55.0137V56.1283H25.0179L25.0166 56.5137H22.9727V58.3576H24.3559V57.5105H25.6383C25.6383 57.5105 26.3125 57.3026 26.3984 56.6025V55.8316C26.3984 55.8316 26.3259 55.1773 25.5631 55.058L22.9727 55.0137Z",
    fill: "#FEFEFE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6064 55.0137V56.1838H10.7908C10.7908 56.1838 10.3986 56.1242 10.5584 57.0059C10.5584 57.0059 10.733 57.3067 11.2997 57.218V56.5553H12.593V58.3576H10.5141C10.5141 58.3576 9.25177 58.3867 9.25177 56.7217C9.25177 56.7217 9.12151 55.5391 10.1086 55.0594L12.6064 55.0137Z",
    fill: "#FEFEFE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5773 55.0137C28.4022 55.0137 27.4434 55.7651 27.4434 56.6856C27.4434 57.6062 28.4022 58.3576 29.5773 58.3576C30.7523 58.3576 31.7111 57.6062 31.7111 56.6856C31.7111 55.7651 30.7523 55.0137 29.5773 55.0137ZM29.6229 57.3303C29.6229 57.3303 29.0146 57.3705 29.0146 56.6884C29.0146 56.6884 28.9689 56.1685 29.4658 56.0216H29.5638C29.5638 56.0216 30.1601 55.9925 30.1534 56.7175C30.1534 56.7175 30.1466 57.2499 29.6229 57.3303Z",
    fill: "#FEFEFE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0261 56.4638V56.0756H15.6385C15.6385 56.0756 15.7809 56.0632 15.7809 56.3072C15.7809 56.3072 15.7392 56.4541 15.6278 56.4652C15.515 56.4735 15.0261 56.4638 15.0261 56.4638ZM13.6993 55.0137L13.6523 55.0234V58.3424H15.0772V57.4967L15.1766 57.5258C15.1766 57.5258 15.6734 58.4255 17.2916 58.3535V57.1154C17.2916 57.1154 16.9264 57.1778 16.643 57.0503C16.643 57.0503 17.1802 56.6413 17.16 56.0784C17.16 56.0784 17.1694 55.223 16.5034 55.0137H13.6993Z",
    fill: "#FEFEFE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3459 55.0137H19.7788L19.7896 57.1598C19.7896 57.1598 20.1428 57.5563 20.5228 57.1224L20.547 55.022H21.9248L21.9006 57.6131C21.9006 57.6131 21.7355 58.3077 21.1486 58.3576H19.0026C19.0026 58.3576 18.4964 58.2994 18.3379 57.523L18.3459 55.0137Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogo);
export default __webpack_public_path__ + "static/media/icon_logo.b36af90275f682110ca73f0d164cc258.svg";
export { ForwardRef as ReactComponent };